export const ensureHttps = (url?: string | null): string | undefined => {
  if (!url) {
    return url ?? undefined;
  }

  if (url.startsWith('//')) {
    return `https:${url}`;
  }

  return url.replace(/^http:\/\//i, 'https://');
};

